module.exports = __webpack_public_path__ + "img/default.6a4c3fed.jpg";